export default __webpack_public_path__ + "images/ED.11408f8.png";